import { Circle } from "@chakra-ui/react";
import React from "react";

interface DotProps {
  index: number;
  onClick: (index: number) => void;
  isActive: boolean;
  disabled: boolean;
}

const getDotColor = ({
  isActive,
  disabled,
}: Pick<DotProps, "isActive" | "disabled">) => {
  if (disabled) {
    return "#888";
  }
  if (isActive) {
    return "#F9A526";
  }
  return "#459AD9";
};

export const PaginationDot = ({
  disabled,
  index,
  onClick,
  isActive,
}: DotProps) => (
  <Circle
    size={"15px"}
    style={{ backgroundColor: getDotColor({ isActive, disabled }) }}
    onClick={disabled ? undefined : () => onClick(index)}
    cursor={disabled ? undefined : "pointer"}
  />
);
